import { render, staticRenderFns } from "./AdminManageSpecialty.vue?vue&type=template&id=5efbd2e8"
import script from "./AdminManageSpecialty.vue?vue&type=script&lang=js"
export * from "./AdminManageSpecialty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports